
module.exports = {
  title: 'Button',
  context: {
    text: 'Learn More',
    url: 'http://www.google.com/',
    class: 'primary'
  },
  variants: [
    {
      name: 'Button Secondary',
      context: {
        text: 'Learn More',
        url: 'http://www.google.com/',
        class: 'secondary'
      }
    },
    {
      name: 'Button Info',
      context: {
        text: 'Learn More',
        url: 'http://www.google.com/',
        class: 'info'
      }
    },
    {
      name: 'Call to Action',
      context: {
        text: 'Learn More',
        url: 'http://www.google.com/',
        class: 'cta',
        tabindex: '-1'
      }
    },
    {
      name: 'CTA Event',
      context: {
        text: 'Learn More',
        class: 'cta'
      }
    },
    {
      name: 'Close',
      context: {
        ariaLabel: 'Close the window'
      }
    },
    {
      name: 'Video Close',
      context: {
        ariaLabel: 'Close the window'
      }
    },
    {
      name: 'Notification Close',
      context: {
        ariaLabel: 'Close the window'
      }
    },
    {
      name: 'Search',
      context: {
        ariaLabel: 'Search'
      }
    },
    {
      name: 'Play',
      context: {
        text: 'Play',
        url: '#',
        class: 'play'
      }
    },
    {
      name: 'Disclosure Toggle',
      context: {
        ariaLabel: 'Toggle'
      }
    },
    {
      name: 'Download',
      context: {
        text: 'Download This File',
        url: 'https://google.com',
        fileType: 'PDF',
        fileSize: '120kb',
        class: 'secondary'
      }
    }
  ]
}
